// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { compactHeaderStyles } from "@rpsc/Overrides/Pages/CompactHeader";
import { DivWrapper } from "@rpsc/XDL/constants";
import { fontConfig } from "@rpsc/XDL/PreStyle/typography";
import { color, layoutContainer, xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

compactHeaderStyles.page = {
    padding: 0, // * Padding doesn't work with fullWidth because of logic on Line 64 if Page component
    fullWidth: [true, true, true, true, true], // make the header full width and control the margins with container css
    css: css`
        top: 0;
        left: 0;
        z-index: ${getProp("theme.zIndex.compactHeader")};
        box-shadow: 0 1px 0 0 ${color("common.border")};
        opacity: 0;
        transform: translateY(0) translateX(0);
        padding: ${props => props.theme.header.padding};
        background-color: ${getColor("common.white")};
        &&&& {
            position: fixed;
        }
        ${xScreen("lte", "md")} {
            display: none;
        }
        box-shadow: ${({ showMainNavigation }: any) =>
            !showMainNavigation
                ? css`
                    0 1px 0 0 ${getColor("common.border")}
                  `
                : "none"};
    `,
};

compactHeaderStyles.logoWrapper = {
    css: css`
        display: flex;
        align-items: center;
        .wrapper,
        .wrapper img {
            // Make logo take full width
            max-width: 100%;
            ${({ isCheckoutPage }: any) => isCheckoutPage && `max-height: 63px; min-height: 63px;`}
        }
    `,
};
compactHeaderStyles.headerLinkListWrapper = {
    css: css`
        &&&& {
            padding: 0;
        }
        .list-wrapper {
            display: flex;
            flex-wrap: nowrap;
        }
    `,
};

compactHeaderStyles.itemsWrapper = {
    css: css`
        display: flex;
        flex-wrap: nowrap;
        gap: 22px;
        justify-content: flex-end;
    `,
};
compactHeaderStyles.rightSectionWrapper = {
    css: css`
        display: grid;
        gap: 48px;
        align-items: center;
        justify-content: space-between;
        ${DivWrapper} > div {
            flex-wrap: nowrap;
        }
        
        grid-template-columns: 1fr auto;
        ${xScreen("lte", "lg")} {
            grid-template-columns: minmax(0, 721px) minmax(277px, 1fr);
        }
    `,
};
compactHeaderStyles.mainNavigationPageWrapper = {
    css: css`
        display: flex;
        gap: 48px;
    `,
};
compactHeaderStyles.mainNavigationWrapper = {
    css: css`
        &&&& {
            padding: 0;
        }
    `,
};
compactHeaderStyles.wrapperStyledWrapper = {
    css: css`
        display: flex;
        flex-grow: 1;
        flex-direction: column;
        gap: 32px;
        position: relative;
    `,
};
compactHeaderStyles.searchWrapper = {
    css: css`
        &, & > div {
            display: flex;
            flex-grow: 1;
        }
    `,
};

compactHeaderStyles.checkoutNeedHelp = {
    css: css`
        margin-left: auto;
        ${TypographyStyle}, a {
            font-size: 14px;
            line-height: 19px;
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            font-weight: ${fontConfig.weight.bold};
        }
    `,
};

compactHeaderStyles.pageInnerWrapper = {
    css: css`
        flex-wrap: nowrap;
        justify-content: unset;
    `,
};
